import { getPublicTrailerPlaybackId } from "./publicTrailer";

export const STUDIO_SCENES_TAB = "studio-scenes";
export const FREE_VIDEOS_TAB = "videos";
export const GALLERY_TAB = "gallery";
export const CAST_TAB = "cast";
export const STORE_TAB = "store";
export const ESCORT_TAB = "escort";
export const DESIGN_SETTINGS_TAB = "design_settings";
export const validTabs = ["videos", "studio-scenes", "gallery", "store", "escort", "cast"];

export function resolveFreeAreaTab(value) {
  if (value === "companion") return ESCORT_TAB;
  if (value === "free") return FREE_VIDEOS_TAB;
  return validTabs.includes(value) || value === DESIGN_SETTINGS_TAB ? value : FREE_VIDEOS_TAB;
}

// Keeps unrelated query params; the default tab is represented by no `tab` param.
export function buildTabSearch(currentSearch, tabId) {
  const params = new URLSearchParams(currentSearch || "");
  const canonicalTab = tabId === "companion" ? ESCORT_TAB : tabId;
  if (canonicalTab === STUDIO_SCENES_TAB || canonicalTab === GALLERY_TAB || canonicalTab === CAST_TAB || canonicalTab === STORE_TAB || canonicalTab === ESCORT_TAB || canonicalTab === DESIGN_SETTINGS_TAB) params.set("tab", canonicalTab);
  else params.delete("tab");
  const next = params.toString();
  return next ? `?${next}` : "";
}

// A scene shown in the Studio Scenes tab must not also appear in the free grid.
export function filterRegularVideos(videos, studioScenes) {
  const studioIds = new Set((studioScenes || []).map((scene) => scene?.id));
  return (videos || []).filter((video) => !studioIds.has(video?.id));
}

const MUX_THUMB_WIDTHS = [320, 640, 960];

export function muxThumbnailUrl(playbackId, width = 640) {
  return `https://image.mux.com/${playbackId}/thumbnail.jpg?width=${width}&fit_mode=smartcrop&time=2`;
}

const isSafeImageUrl = (value) =>
  typeof value === "string" && /^(https?:\/\/|\/(?!\/)|data:image\/)/i.test(value.trim());

// Ordered candidates, best first. Only the public trailer id is ever used for Mux images;
// the full-video mux_playback_id is signed/protected and must never be requested here.
export function getThumbnailSources(video) {
  if (!video) return [];
  const sources = [];
  const seen = new Set();
  const add = (src, srcSet) => {
    if (!isSafeImageUrl(src)) return;
    const clean = src.trim();
    if (seen.has(clean)) return;
    seen.add(clean);
    sources.push(srcSet ? { src: clean, srcSet } : { src: clean });
  };

  add(video.cover_image);
  add(video.thumbnail_url);
  add(Array.isArray(video.scene_photos) ? video.scene_photos[0] : null);

  const trailerId = getPublicTrailerPlaybackId(video) || video.restricted_playback_id || null;
  if (trailerId) {
    add(
      muxThumbnailUrl(trailerId, 640),
      MUX_THUMB_WIDTHS.map((w) => `${muxThumbnailUrl(trailerId, w)} ${w}w`).join(", "),
    );
  }
  return sources;
}

export const THUMBNAIL_SIZES = "(min-width: 1280px) 25vw, (min-width: 768px) 33vw, 100vw";
